module.exports = __webpack_public_path__ + "img/wild-rag-deck-02.e92357a8.jpeg";